
import { Component, Prop, Vue } from 'vue-property-decorator';
import { mdiChevronUp, mdiChevronDown } from '@mdi/js';

@Component
export default class OrderSelector extends Vue{
	mdiChevronUp = mdiChevronUp
	mdiChevronDown = mdiChevronDown

	@Prop({ required: true }) private order: number;
	@Prop({ default: 'baColorSuperLightBlue' }) private color: string;
	@Prop({ default: 'baColorPrimaryBlue' }) private borderColor: string;
	
}
